<script setup lang="ts">
import {
  COMPANY_TELEGRAM_LINK,
  COMPANY_FACEBOOK_LINK,
  COMPANY_INSTAGRAM_LINK,
} from '@/shared/constants/contacts';

import TelegramLogo from '@/shared/ui/Icons/TelegramLogo.vue';
import FacebookLogo from '@/shared/ui/Icons/FacebookLogo.vue';
import InstagramLogo from '@/shared/ui/Icons/InstagramLogo.vue';
import LangButton from '@/widgets/header/ui/LangButton.vue';
import TelegramSupportButton from '@/widgets/telegramSupportButton/index';

const { t } = useI18n();
const localePath = useLocalePath();
const isMobile = inject('isMobile');

const links = ref([
  {
    name: t('aboutCompany'),
    link: localePath('about'),
  },
  {
    name: t('contacts'),
    link: localePath('contacts'),
  },
  {
    name: t('forBusiness'),
    link: localePath('for-business'),
  },
  {
    name: t('pickupPoints'),
    link: localePath('pickup-points'),
  },
  {
    name: t('frequentlyAskedQuestions'),
    link: localePath('faq'),
  },
  {
    name: t('deliveryAndPayment'),
    link: localePath('delivery-payment'),
  },
]);
</script>
<template>
  <div class="menu">
    <ul class="menu__links">
      <li v-for="link in links" :key="link.name">
        <nuxt-link :to="link.link">{{ link.name }}</nuxt-link>
      </li>
    </ul>
    <div class="menu__support">
      <TelegramSupportButton />
    </div>
    <div class="menu__social">
      <span>{{ t('ourSocialNetworks') }}</span>
      <ul>
        <li>
          <a
            :href="COMPANY_TELEGRAM_LINK"
            class="menu__social-link"
            aria-label="Telegram"
            target="_blank"
          >
            <TelegramLogo class="menu__social-icon" />
          </a>
        </li>
        <li>
          <a
            :href="COMPANY_FACEBOOK_LINK"
            class="menu__social-link"
            aria-label="Facebook"
            target="_blank"
          >
            <FacebookLogo class="menu__social-icon" />
          </a>
        </li>
        <li>
          <a
            :href="COMPANY_INSTAGRAM_LINK"
            class="menu__social-link"
            aria-label="Instagram"
            target="_blank"
          >
            <InstagramLogo class="menu__social-icon" />
          </a>
        </li>
      </ul>
    </div>
    <ClientOnly v-if="isMobile">
      <LangButton />
    </ClientOnly>
  </div>
</template>

<style lang="less" scoped>
.menu {
  display: flex;
  flex-direction: column;
  gap: @size-x4;

  &__links {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;

    li a {
      .color-change-hover();

      font-size: @size-x4;
      color: @color-oxford-blue;
      font-weight: 400;
      color: @color-oxford-blue;
      line-height: @size-x5;
    }
  }

  &__support {
    max-width: 230px;
  }

  &__social {
    display: flex;
    flex-direction: column;
    gap: @size-x2;
    align-items: flex-start;

    span {
      color: @color-silver-chalice;
      font-weight: 500;
      font-size: 14px;
      line-height: 100%;
    }

    ul {
      display: grid;
      grid-template-columns: repeat(3, 28px);
      gap: 18px;
      align-items: center;

      li {
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
